import { useDispatch, useSelector } from "react-redux";
import { Icon, Input, Message, Radio, Segment, Select } from "semantic-ui-react";
import {
    SetRAOF299NonSecured,
    SetRAOF299Secured,
    SetRAOMW,
    SetRAOR1,
    SetRAOR2,
    SetRAOR3AllNecs,
    SetRAOR3NonSecured,
    SetRAOR3Secured,
    SetRAOR4,
    SetRAOR5,
    SetRaoSelectionResultObjective,
} from "../../../../../actions/raoReportActions";
import { AppState } from "../../../../../store/configureStore";
import { raoReportSecuredOptions } from "../../../../../store/raoReportReducer";
import { Justifications } from "./Justifications";
import "./RAOReport.css";

export const RAOReport = () => {
    const dispatch = useDispatch();
    const raoReport = useSelector((state: AppState) => state.raoReport);

    return (
        <Segment id="segment-RAOReport-a" className="raoreport-container transition-container">
            <section id="section-RAOReport-a" className="reports-container-half">
                <section id="section-RAOReport-b" className="reports-half">
                    <p id="p-RAOReport-F299">F299: detailed RAO report</p>
                    <div id="div-RAOReport-a" className="raoreport-case-container">
                        <div id="div-RAOReport-b" className="reports-field">
                            <label id="label-justification-create">Create for secured vertices</label>
                            <Select
                                id="select-RAOReport-b"
                                selectOnBlur={false}
                                value={raoReport.f299Secured}
                                options={raoReportSecuredOptions}
                                onChange={(e, data: any) => dispatch(SetRAOF299Secured(data.value))}
                            />
                        </div>
                        {raoReport.f299Secured === 2 && (
                            <div id="div-RAOReport-c" className="reports-field">
                                <label id="label-justification-enter">Enter MW</label>
                                <Input
                                    id="input-RAOReport-c"
                                    name="mw"
                                    value={raoReport.mw}
                                    type="number"
                                    pattern="^([-+,0-9.]+)"
                                    onChange={(e: any) => dispatch(SetRAOMW(e))}
                                />
                            </div>
                        )}
                    </div>
                    <div id="div-RAOReport-d" className="reports-field">
                        <Radio
                            toggle
                            checked={raoReport.f299NonSecured}
                            onChange={() => dispatch(SetRAOF299NonSecured())}
                            label="Create for non-secured vertices"
                        />
                    </div>
                    <div id="div-RAOReport-e" className="reports-field">
                        <p id="p-justification-R1">R1</p>
                        <Radio
                            toggle
                            label="Create report"
                            checked={raoReport.r1}
                            onChange={() => dispatch(SetRAOR1())}
                        />
                    </div>
                    <div id="div-RAOReport-f" className="reports-field">
                        <p id="p-justification-R2">R2</p>
                        <Radio
                            toggle
                            label="Create report"
                            checked={raoReport.r2}
                            onChange={() => dispatch(SetRAOR2())}
                        />
                    </div>
                    <div id="div-RAOReport-g" className="reports-field">
                        <p id="p-justification-R3">R3</p>
                        <Radio
                            toggle
                            label="Create for secured vertices"
                            checked={raoReport.r3Secured}
                            onChange={() => dispatch(SetRAOR3Secured())}
                        />
                        <Radio
                            toggle
                            label="Create for non-secured vertices"
                            checked={raoReport.r3NonSecured}
                            onChange={() => dispatch(SetRAOR3NonSecured())}
                        />
                        <Radio
                            toggle
                            label="Print RAO Selection Result - Objective for each iteration"
                            checked={raoReport.raoSelectionResultObjective}
                            onChange={() => dispatch(SetRaoSelectionResultObjective())}
                        />
                        <Radio
                            toggle
                            label="All NECs"
                            checked={raoReport.r3AllNecs}
                            onChange={() => dispatch(SetRAOR3AllNecs())}
                        />
                    </div>
                    <div id="div-RAOReport-h" className="reports-field">
                        <p id="p-justification-R4">R4</p>
                        <Radio
                            toggle
                            label="Create for secured vertices"
                            checked={raoReport.r4}
                            onChange={() => dispatch(SetRAOR4())}
                        />
                    </div>
                    <div id="div-RAOReport-i" className="reports-field">
                        <p id="p-justification-R5">R5</p>
                        <Radio
                            toggle
                            label="Create report"
                            checked={raoReport.r5}
                            onChange={() => dispatch(SetRAOR5())}
                        />
                    </div>
                </section>
                <Justifications />
            </section>
            <Message id="message-justification-a" icon>
                <Icon id="icon-justification-infoCircle" name="info circle" />
                <Message.Content id="messageContent-justification-a">
                    <p id="p-justification-R1-outputs">R1: outputs from CCCt based on intermediate domain files</p>
                    <p id="p-justification-R2-default">R2: default validation scenario as input</p>
                    <p id="p-justification-R3-remedial">R3: remedial actions optimization details</p>
                    <p id="p-justification-R4-results">R4: results of Validation process with IVA values report</p>
                    <p id="p-justification-R5-IVA-daily">R5: IVA Daily Report</p>
                    <hr id="hr-justification-a"/>
                    <p id="p-justification-beforeOptimization">Before Optimization - B88</p>
                    <p id="p-justification-afterB57">After PRA - B57</p>
                    <p id="p-justification-afterB54">After PRA+CRA - B54</p>
                    <p id="p-justification-flowA01">Flow - A01</p>
                    <p id="p-justification-MW-A02">PATL MW - A02</p>
                    <p id="p-justification-Amp-A02">PATL Amp - A02</p>
                    <p id="p-justification-MW-A07">TATL MW - A07</p>
                    <p id="p-justification-Amp-A07">TATL Amp - A07</p>
                    <p id="p-justification-Frm-A03">Frm - A03</p>
                    <p id="p-justification-PTDF-Z11">Sum PTDF - Z11</p>
                    <p id="p-justification-Margin-Z12">PATL Abs Margin - Z12</p>
                    <p id="p-justification-Margin-Z14">TATL Abs Margin - Z14</p>
                    <p id="p-justification-Z13">PATL Obj Value - Z13</p>
                    <p id="p-justification-Z15">TATL Obj Value - Z15</p>
                    <p id="p-justification-Z16">Loop Flow - Z16</p>
                    <p id="p-justification-Z17">Max Loop Flow - Z17</p>
                </Message.Content>
            </Message>
        </Segment>
    );
};
